export default __webpack_public_path__ + "static/dancing.db9c03fe8bd9c14af283fcda30b8e3a3.png";